import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AwakenPopoverComponent } from './awaken-popover.component';

@NgModule({
  imports: [ CommonModule, FormsModule, IonicModule,],
  declarations: [AwakenPopoverComponent],
  exports: [AwakenPopoverComponent]
})
export class AwakenPopoverComponentModule {}
